<template>
  <div class="module-wrap module-learn-plan">
    <h2 >{{moduleTitle}}</h2>
    <div class="plan-card">
      <h4 class="title">预计提高同步课学习效率50%</h4>
      <ul class="item-ul">
        <li>
          <p>打地基学习</p>
          <p>{{planData.foundationStudyTime}}小时</p>
        </li>
        <li>+</li>
        <li>
          <p>同步课学习</p>
          <p>{{planData.nowGradeInfoList.learnTime}}小时</p>
        </li>
      </ul>
    </div>
    <p class="text-plan">通过<span>每周8小时</span>打地基，消灭<span>
      {{planData.foundationLoNum}}</span>个知识漏洞，避免低年级知识漏洞进一步影响同步课。
消灭知识漏洞后，同步课学习效率至少提高50%。</p>
  </div>
</template>

<script>

export default {
  name: 'ModuleLearnPlan',
  data() {
    return {

    };
  },
  props: {
    isMobile: {
      type: Boolean,
      require: true,
    },
    moduleTitle: {
      type: String,
      default: '',
    },
    planData: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h2{
  width: 358px;
  height: 40px;
  margin: 58px auto 32px auto;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  background: url("~@/assets/img/sub_headbg.png") no-repeat;
  background-size: cover;
}
.module-learn-plan {
  margin: 0 32px;
  .plan-card{
    box-sizing: border-box;
    height: 181px;
    padding-top: 12px;
    background: linear-gradient(90deg, #E4EAFF 0%, #E1F5FF 100%);
    border-radius: 8px;
    .title{
      display: inline-block;
      padding: 5px 24px;
      line-height: 22px;
      background: #4E74FF;
      border-radius: 0px 100px 100px 0px;
      color: #fff;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .item-ul{
      display: flex;
      justify-content: space-around;
      padding: 29px 50px 0 50px;
      > li{
        text-align: center;
        color: #28272A;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        >p{
          &:first-child{
            font-size: 28px;
            line-height: 40px;
          }
          &:last-child{
            font-size: 24px;
            line-height: 33px;
          }
        }
      }
    }
  }
  .text-plan{
    padding-top: 14px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    >span{
      color: #FF9A42;
    }
  }
}
</style>
<style scoped>
  @media screen and (max-device-width: 1024px) {
  }

</style>
